module.exports = __webpack_public_path__ + "static/media/Aviation and jet fuel.6f14e661.png";